import { jsx } from 'react/jsx-runtime';
import { cssVar } from '../../theme/variables.js';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import React__default from 'react';
import { styled } from 'styled-components';
import SvgCheckboxCheck from './assets/checkbox-check.svg.js';

const IndeterminateSymbol = styled.div.withConfig({
  displayName: "Checkbox__IndeterminateSymbol",
  componentId: "sc-191a41ac-0"
})([
  `width:9px;height:1.5px;background:white;border-radius:1.5px;`
]);
const IconCheckmark = styled(SvgCheckboxCheck).withConfig({
  displayName: "Checkbox__IconCheckmark",
  componentId: "sc-191a41ac-1"
})([
  `color:white;`
]);
const CheckboxRoot = styled(CheckboxPrimitive.Root).withConfig({
  displayName: "Checkbox__CheckboxRoot",
  componentId: "sc-191a41ac-2"
})([
  `flex-shrink:0;background-color:`,
  `;border:1px solid `,
  `;border-radius:`,
  `;display:flex;align-items:center;justify-content:center;width:16px;height:16px;&[data-state='checked'],&[data-state='indeterminate']{background-color:`,
  `;border-color:`,
  `;color:white;}`
], cssVar["color-bg-tertiary"], cssVar["color-border-primary"], cssVar["radius-input-sm"], cssVar["color-app-primary"], cssVar["color-app-primary"]);
const CheckboxIndicator = CheckboxPrimitive.Indicator;
const CheckboxDefault = /* @__PURE__ */ React__default.forwardRef((props, ref) => /* @__PURE__ */ jsx(CheckboxRoot, {
  ...props,
  ref,
  children: /* @__PURE__ */ jsx(CheckboxIndicator, {
    children: props.checked === "indeterminate" ? /* @__PURE__ */ jsx(IndeterminateSymbol, {}) : /* @__PURE__ */ jsx(IconCheckmark, {})
  })
}));
CheckboxDefault.displayName = "Checkbox";
const Checkbox = {
  Root: CheckboxRoot,
  Indicator: CheckboxIndicator,
  Default: CheckboxDefault,
  Checkmark: IconCheckmark,
  IndeterminateSymbol
};

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
